function unHyphenate(source) {
  return source.replace(/(\w)(-)(\w)/g, "$1 $3");
}
import { validateTidalLicense } from "../../base/index.js";
validateTidalLicense();
export {
  unHyphenate
};
//# sourceMappingURL=unHyphenate.js.map
